import { Collection } from "vue-mc"
import serviceDeliveryFormModel from "@/models/serviceDeliveryFormModel"

import Vue from "vue";

export default class serviceDeliveryFormCollection extends Collection {

	model(){
		return serviceDeliveryFormModel;
	}

	defaults() {
		return {
			inBuiltApi: Vue.prototype.$interpretersApiUrl,
			methodTypes: 'list', // with collection it has a issue. Fix later
			type: 'Inter',
			data: {
				jobID : localStorage.getItem('jwt')
			},
			dbData: {}
		}
	}

	options() {
		return {
			methods: {
				list: 'GET',
				getUploadedList: 'GET'
			}
		}
	}

	routes() {
		return {
			fetch: 'job/slips/pending',
			list: 'job/slips/pending/{type}',
			getUploadedList: 'job/slips/updated'
		}
	}

	requestRoute() {

		let headers = {
			Bearer: localStorage.getItem('jwt')
		};
		let method = this.getOption('methods.' + this.methodTypes);
		let route = this.getAttributes().inBuiltApi + this.getRoute(this.methodTypes);
		let params = this.getRouteParameters();
		let url = this.getURL(route, params);
		let data = this.getAttributes().data;

		// console.log(headers, method, url, data);

		return this.getRequest({headers, method, url, data}).send();
	}

	getSDFList(SDType) {
		this.methodTypes = 'list';
		this.getAttributes().type = SDType;
		return this.requestRoute();
	}

	getSDFUList() {
		this.methodTypes = 'getUploadedList';
		return this.requestRoute();
	}
}
